import FilterScheduledPauses from "../filter";
import reqPausaProgramada from "../../../../services/reqMultiTenant/reqPausaProgramada";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import Form from "../form";
import LibDateTime from "../../../../util/libDateTime";

const MainRegisterScheduledPauses = () => {
	const options = {
		id: "id_pausa_programada",
		ident: "scheduledPauses",
		identFilter: "filterScheduledPauses",
		title: "Pausas Programadas",
		subTitle: "Gestão de Feriados e Exceções",
		notice: "As Pausas Programadas permitem bloquear o funcionamento em datas específicas (como feriados ou reformas). Você pode pausar apenas o Delivery e manter a Loja aberta para retiradas, por exemplo.",
		tableColumns: [
			{ key: "data_inicio_str", label: "Início", align: "left" },
			{ key: "data_fim_str", label: "Término", align: "left" },
			{ key: "motivo", label: "Motivo", align: "left" },
			{ key: "tipo", label: "Tipo / Ref.", align: "center" },
			{ key: "ativo", label: "Ativo", align: "center", format: "badgeAtivoSoft" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [
			{ id: 1, label: "Motivo (Ex: Natal)", value: "motivo" },
			{ id: 2, label: "Tipo / Modalidade", value: "tipo" },
		],
	};

	const formatData = (item) => {
		if (!item) return item;

		const id_pausa_programada = item.id_pausa_programada || item.ID_PAUSA_PROGRAMADA;

		return {
			...item,
			id_pausa_programada,
			data_inicio: LibDateTime.formatDelphiLocalForInput(item.data_inicio || item.DATA_INICIO),
			data_fim: LibDateTime.formatDelphiLocalForInput(item.data_fim || item.DATA_FIM),
			data_inicio_str: LibDateTime.parseDelphiLocal(item.data_inicio || item.DATA_INICIO),
			data_fim_str: LibDateTime.parseDelphiLocal(item.data_fim || item.DATA_FIM),
			ativo: item.ativo !== undefined ? item.ativo : item.ATIVO === 1 || item.ATIVO === true,
		};
	};

	const fetch = async (filterData, newPage) => {
		let { param, paramValue, active } = filterData;
		const response = await reqPausaProgramada.list(param, paramValue, active, newPage);

		if (response && response.data && Array.isArray(response.data)) {
			response.data = response.data.map(formatData);
		}

		return response;
	};

	const fetchID = async (currentId) => {
		const response = await reqPausaProgramada.listID(currentId);

		if (response && response.data) {
			const record = Array.isArray(response.data) ? response.data[0] : response.data;
			response.data = formatData(record);
		}

		return response;
	};

	const insert = async (data) => {
		return await reqPausaProgramada.insert(data);
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={Form} FormFilter={FilterScheduledPauses} />
		</RegisterProvider>
	);
};

export default MainRegisterScheduledPauses;
